import React, { useState } from "react";
import { useStaffLogin } from "./useStaffLogin";

export const StaffLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const {staffLogin, error, isLoading} = useStaffLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Add your login logic here
    //console.log("Email:", email, "Password:", password);

    await staffLogin(email,password);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded shadow-lg">
        <h1 className="text-2xl font-bold text-center mb-6">AMAX Staff Login</h1>


            {/* Display Error Message */}
            {error && (
                                <p className="text-red-500 text-sm mt-2">
                                {error}
                                </p>
                            )}

                   {/* Display Loading Indicator */}
              {isLoading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )} 

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter your email"
              required
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter your password"
              required
            />
          </div>
          <div>
            <button
              type="submit"
              className="w-full py-2 px-4 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Login
            </button>
          </div>
        </form>
       
      </div>
    </div>
  );
};
